import CoveoPlaceHolderCardsLoader from "../CoveoPlaceHolderCardsLoader";
import CoveoPlaceholderResultsLoader from "../CoveoPlaceholderResultsLoader";
import ClientHomeTabLoader from "./ClientHomeTabLoader";

const ClientHomeLoader = ({ numberOfCards }) => {
	return (
		<div>
			<ClientHomeTabLoader />
			<div className="container">
				<CoveoPlaceholderResultsLoader />
				<CoveoPlaceHolderCardsLoader numberOfCards={numberOfCards} />
			</div>
		</div>
	);
};

export default ClientHomeLoader;
